import React from 'react'
import styled from 'styled-components'

import loader from '../loader.gif'

const Root = styled.div`
  height: 600px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Image = styled.img`
  height: 64px;
  width: 64px;
`

export default function Loader () {
  return (
    <Root>
      <Image alt='Loading...' src={loader} />
    </Root>
  )
}